import Image from "src/Components/Common/Image";
import setCurrentPage from "src/Utils/setCurrentPage";

const USE_CASES_EV = [
  {
    title: "ORDER \nMANAGEMENT",
    subtitle: "Use case 1",
    text: "Enhance customer experiences \nthrough our agile, touchless order \nmanagement solution.",
    image: "EV/UseCase_1.png",
    button: {
      label: "Choose",
      onClick: () => {
        setCurrentPage(404);
      },
      endIcon: "arrow-right",
    },
  },
  {
    title: "TOWER LEASE \nCONTRACTs",
    subtitle: "Use case 2",
    text: "Maximize business results with \nbetter negotiations, insights, and \ncontract clarity.",
    image: "EV/UseCase_3.png",
    button: {
      label: "Choose",
      onClick: () => {
        setCurrentPage(410);
      },
      endIcon: "arrow-right",
    },
  },
  {
    title: "Customer \nservice",
    subtitle: "Use case 3",
    text: "Transform customer service with \ncutting-edge Automation and \nGen-AI.",
    image: "EV/UseCase_4.png",
    imageStyle: { width: "351px" },
    button: {
      label: "Choose",
      onClick: () => {
        setCurrentPage(414);
      },
      endIcon: "arrow-right",
    },
  },
  {
    title: "GEN AI-BASED CALL \nCENTER AGENT \nTRAINING",
    subtitle: "Use case 4",
    text: "Empower teams with real-time, \nGen-AI-enabled conversations.",
    image: "EV/UseCase_5.png",
    imageStyle: { width: "354px" },
    button: {
      label: "Choose",
      onClick: () => {
        setCurrentPage(416);
      },
      endIcon: "arrow-right",
    },
  },
];

export const DATA_USE_CASES_EV = {
  title: "Empower Your Digital Core With The Digital Edge",
  bgImage: "EV/EV_demo_Intro_03.png",
  useCases: USE_CASES_EV,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(402),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", right: "0px", bottom: "229px" }}>
      <Image imagePath="EV/EV_use_cases_right_image.png" />
    </div>
  ),
};
